import { apiPost } from "./apiClient";
import { runBusinessSend } from "./businessSendAttempt";

// Generic primitive behind every `POST /queries/:id/<action>` lifecycle
// transition (cancel, move-status, move-status-forward, reassign, unpark,
// notify-unavailable-parts, request-billing-details) — the modals-misc
// domain wraps this with each action's specific field mapping. The server
// takes the actor from the access token; `actor` only scopes the saved send.
export function postQueryAction(queryPk, action, payload, { directWati = true, actor } = {}) {
  if (directWati && ["notify-unavailable-parts", "request-billing-details"].includes(action)) {
    return runBusinessSend(actor, queryPk, action, payload);
  }
  return apiPost(`/queries/${queryPk}/${action}`, payload).then(res => res.data);
}
